import { lazy } from 'react';

export const IncCorListLazy = lazy(() => import('./IncCorList'));
